import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css'

const Card = (props) => {
  useEffect(() =>{
    Aos.init({duration: 500 , once: true, easing: "ease-in-out" })
  },[])
  return (
   <div className="timeline__items" data-aos = "fade-up" data-aos-anchor-placement="center-bottom">
    <i className={props.icon}></i>
    <span className="timeline__date">{props.year}</span>
    <h3 className="timeline__title">{props.title}</h3>
    <p className="timeline__text">{props.desc}</p>
    <p className="timeline__major">{props.major}</p>
    <p className="timeline__text">{props.summary}</p>

   </div>
  )
}

export default Card;